<template>
  <modal id="bank-modal">
    <div class="bank-modal">
      <h2>Connect to Stripe Account</h2>
      <span class="ico__close ico" @click="$bvModal.hide('bank-modal')">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
          <g clip-path="url(#clip0)">
            <path
              d="M12.5894 12.0005L17.2114 7.37843C17.3741 7.2157 17.3741 6.95187 17.2114 6.78916C17.0486 6.62645 16.7848 6.62643 16.6221 6.78916L12.0001 11.4112L7.37806 6.78916C7.21534 6.62643 6.9515 6.62643 6.78879 6.78916C6.62609 6.95189 6.62607 7.21572 6.78879 7.37843L11.4108 12.0004L6.78879 16.6225C6.62607 16.7852 6.62607 17.049 6.78879 17.2117C6.87015 17.2931 6.97679 17.3338 7.08344 17.3338C7.19009 17.3338 7.29671 17.2931 7.37809 17.2117L12.0001 12.5897L16.6221 17.2117C16.7034 17.2931 16.8101 17.3338 16.9167 17.3338C17.0234 17.3338 17.13 17.2931 17.2114 17.2117C17.3741 17.049 17.3741 16.7852 17.2114 16.6225L12.5894 12.0005Z"
              fill="#606770"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="10.6667"
                height="10.6667"
                fill="white"
                transform="translate(6.66675 6.66663)"
              />
            </clipPath>
          </defs>
        </svg>
      </span>
      <p>
        Please select your country. You will be redirected to the Stripe where
        you will be able to input your banking information.
      </p>
      <div class="custom__select" :class="{ active: dropdown == true }">
        <div @click="dropdown = true" class="wrapper_custom-dropdown">
          <span class="placeholder">{{
            country.text || "Choose Country"
          }}</span>
          <span>&#9662;</span>
        </div>
        <div class="option-custom__select">
          <div
            class="option__choice"
            v-for="(country, index) in countries"
            :key="index"
            @click="countrySelected(country)"
          >
            {{ country.text }}
          </div>
        </div>
        <b-button variant="primary btn-round-fill" @click="createAccount"
          >Create Account</b-button
        >
      </div>
    </div>
    <div class="overlay" @click="dropdown = false" v-if="dropdown"></div>
  </modal>
</template>

<script>
import firebase from "firebase";
import { mapGetters } from "vuex";
import Modal from "@/components/common/modal";
export default {
  data() {
    return {
      country: {
        text: "",
        value: ""
      },
      dropdown: false,
      countries: [
        { text: "Australia", value: "AU" },
        { text: "Austria", value: "AT" },
        { text: "Belgium", value: "BE" },
        { text: "Bulgaria", value: "BG" },
        { text: "Canada", value: "CA" },
        { text: "Cyprus", value: "CY" },
        { text: "Czech Republic", value: "CZ" },
        { text: "Denmark", value: "DK" },
        { text: "Estonia", value: "EE" },
        { text: "Finland", value: "FI" },
        { text: "France", value: "FR" },
        { text: "Germany", value: "DE" },
        { text: "Greece", value: "GR" },
        { text: "Hong Kong", value: "HK" },
        { text: "Ireland", value: "IE" },
        { text: "Italy", value: "IT" },
        { text: "Japan", value: "JP" },
        { text: "Latvia", value: "LV" },
        { text: "Lithuania", value: "LT" },
        { text: "Luxembourg", value: "LU" },
        { text: "Malta", value: "MT" },
        { text: "Netherlands", value: "NL" },
        { text: "New Zealand", value: "NZ" },
        { text: "Norway", value: "NO" },
        { text: "Poland", value: "PL" },
        { text: "Portugal", value: "PT" },
        { text: "Romania", value: "RO" },
        { text: "Singapore", value: "SG" },
        { text: "Slovakia", value: "SK" },
        { text: "Slovenia", value: "SI" },
        { text: "Spain", value: "ES" },
        { text: "Sweden", value: "SE" },
        { text: "Switzerland", value: "CH" },
        { text: "United Kingdom", value: "GB" },
        { text: "United States", value: "US" }
      ]
    };
  },
  components: {
    Modal
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    })
  },
  methods: {
    countrySelected(country) {
      this.dropdown = false;
      this.country = country;
      console.log(this.dropdown);
    },
    createAccount() {
      let func = firebase.functions().httpsCallable("createConnectedAccount");
      func({
        type: "express",
        email: this.profile.email,
        country: this.country.value
      })
        .then(res => {
          console.log(res);
          let account = {
            uid: this.user.uid,
            account_id: res.data.id,
            type: res.data.type,
            email: res.data.email
          };
          this.createAccountLink(res.data.id);
          this.addAccount(account);
        })
        .catch(e => {
          console.log(e);
        });
    },
    createAccountLink(account_id) {
      let func = firebase
        .functions()
        .httpsCallable("createConnectedAccountLink");
      func({
        account: account_id,
        refresh_url: `${process.env.VUE_APP_BASE_URL}/refresh-account-link`,
        return_url: `${process.env.VUE_APP_BASE_URL}/manage/guide`,
        type: "account_onboarding"
      })
        .then(res => {
          location.replace(res.data.url);
        })
        .catch(e => {
          console.log(e);
        });
    },
    addAccount(account) {
      this.$store.dispatch("stripe/addConnectedAccount", account).then(() => {
        this.getAccount();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-family: "Nunito", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 33px;
  color: #474d52;
  text-align: center;
}
.ico__close {
  position: absolute;
  top: 18px;
  cursor: pointer;
  right: 25px;
}
p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #8d99a0;
  margin-top: 32px;
}
.custom__select {
  cursor: pointer;
  height: 47px;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 40px;

  color: #000;
  user-select: none;
  position: relative;
  .wrapper_custom-dropdown {
    padding: 10px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .placeholder {
    color: #8d99a0;
  }
  .option-custom__select {
    display: none;
  }
  &.active {
    border-radius: 40px 40px 0 0;
    .option-custom__select {
      display: block !important;
      position: absolute;
      z-index: 2;
      left: 0;
      top: 100%;
      width: 100%;
      height: 200px;
      background-color: #fff;
      border-radius: 0 0 20px 20px;
      padding: 0 24px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 6px;
        height: 8px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: rgba(51, 51, 51, 0.301);
        border-radius: 10px;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #222;
      }
      .option__choice {
        font-weight: 600;
        font-size: 16px;
        line-height: 26px;
        transition: all 0.3s ease;
        &.active,
        &:hover {
          color: #557efb;
        }
      }
    }
  }
}
.btn-round-fill {
  width: 100%;
  margin-top: 24px;
}
.overlay {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
</style>
